import { Box } from '@mui/system';
import ReactLoading from 'react-loading';
import useSettings from 'src/hooks/useSettings';

interface Type {
  loaderType?:
    | 'blank'
    | 'balls'
    | 'bars'
    | 'bubbles'
    | 'cubes'
    | 'cylon'
    | 'spin'
    | 'spinningBubbles'
    | 'spokes';
  width?: number;
  height?: number;
}
export default function Loader({ loaderType = 'bubbles', width = 50, height }: Type) {
  const { themeMode } = useSettings();
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        height: height ? height : 500,
      }}
    >
      <ReactLoading
        type={loaderType}
        color={themeMode === 'light' ? 'black' : 'white'}
        height={100}
        width={width}
      />
    </Box>
  );
}
